import Review from './Review.container';

export default Review;
